import { paths } from "from-start/scene/resources";
import { html, LitElement } from "lit-element";
import { nothing } from "lit-html";
import { styleMap } from "lit-html/directives/style-map";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
class TextElement extends LitElement {
    constructor() {
        super(...arguments);
        this.text = "";
    }
    static get properties() {
        return {
            text: { type: String },
        };
    }
    createRenderRoot() {
        return this;
    }
    render() {
        const klass = "mv2 db jh-green jh-unindent";
        const natashaIconStyle = {
            width: "42px",
            height: "42px",
            "margin-right": "30px",
        };
        return html `<div class="flex pl4">
      <img
        src="${paths.chatbotNatashaIcon}"
        style=${styleMap(natashaIconStyle)}
      />
      <span class="${klass}">${unsafeHTML(this.text)}</span>
    </div>`;
    }
}
customElements.define("jh-chat-bot-content-text-element", TextElement);
class NatashaImage extends LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        const klass = "mv3 db jh-green jh-unindent";
        const natashaIconStyle = {
            width: "42px",
            height: "42px",
            "margin-right": "30px",
        };
        return html `<div class="flex pl4">
      <img
        src="${paths.chatbotNatashaIcon}"
        style=${styleMap(natashaIconStyle)}
        class="mt2"
      />
      <span class="${klass}">:</span>
      <img class="${klass}" src="${paths.chatbotNatashaGif}" />
    </div>`;
    }
}
customElements.define("jh-chat-bot-content-natasha-image", NatashaImage);
class Response extends LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        const style = {
            bottom: "0",
            "z-index": "3",
        };
        return html `<img
      class="absolute pointer-allow"
      style="${styleMap(style)}"
      src="${paths.chatbotIconGif}"
    />`;
    }
}
customElements.define("jh-chat-bot-content-response", Response);
class ResponseText extends LitElement {
    constructor() {
        super(...arguments);
        this.text = "";
    }
    static get properties() {
        return {
            text: { type: String },
        };
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html `<div class="mv2 flex justify-end jh-purple pr4">
      <span>${this.text}</span>
    </div>`;
    }
}
customElements.define("jh-chat-bot-content-response-text", ResponseText);
/**
 * Progress는 0부텨 100까지 값이다.
 * clickTicket 이벤트 발생
 */
class Printing extends LitElement {
    constructor() {
        super(...arguments);
        this.progress = 0;
    }
    static get properties() {
        return {
            progress: { type: Number },
        };
    }
    createRenderRoot() {
        return this;
    }
    updated() {
        this.closest("jh-chat-bot-content").requestUpdate();
    }
    render() {
        // 이미지가 로딩되기 전에 스크롤하기 위해서 width, height를 세팅함
        const style = {
            width: "443px",
            height: "161px",
            "margin-left": "90px",
        };
        const loadingStyle = {
            width: `${this.progress}%`,
        };
        // 이미지가 로딩되기 전에 스크롤하기 위해서 width, height를 세팅함
        const clickStyle = {
            "margin-left": "160px",
            width: "300px",
            height: "50px",
        };
        return html `<div>
      <div
        style="${styleMap(style)}"
        class="relative pointer-allow"
        @click=${this.handleClick}
      >
        <img class="absolute" src="${paths.chatbotTicket1Gif}" />
        <div class="absolute w-100 h-100">
          <img
            class="object-fit-cover object-position-left h-100"
            style="${styleMap(loadingStyle)}"
            src="${paths.chatbotTicket2Gif}"
          />
        </div>
      </div>
      ${this.progress === 100
            ? html `<img
            src="${paths.chatbotTicket3Gif}"
            style="${styleMap(clickStyle)}"
          />`
            : nothing}
    </div>`;
    }
    handleClick(ev) {
        ev.stopPropagation();
        this.dispatchEvent(new CustomEvent("clickTicket"));
    }
}
customElements.define("jh-chat-bot-content-printing", Printing);
class ChatbotTop extends LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        const top = 0;
        const first = {
            top: `${top}px`,
        };
        const second = {
            top: `${top + 81}px`,
        };
        return html `
      <img
        src="${paths.chatbotLayoutGif3}"
        class="absolute"
        style="${styleMap(first)}"
      />
      <img
        src="${paths.chatbotLayoutGif1}"
        class="absolute"
        style="${styleMap(second)}"
      />
    `;
    }
}
customElements.define("jh-chat-bot-top", ChatbotTop);
class ChatbotBottom extends LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        const style = {
            bottom: "0",
        };
        return html `
      <img
        src="${paths.chatbotLayoutGif2}"
        style=${styleMap(style)}
        class="absolute"
      />
    `;
    }
}
customElements.define("jh-chat-bot-bottom", ChatbotBottom);
//# sourceMappingURL=chatBotContentChildren.js.map